import { HIERARCHIES_API_BASE_URL_V7 } from '../config';

export const HierarchiesAPIRoutes = {
  getHierarchies: () => `${HIERARCHIES_API_BASE_URL_V7}/list`,
};
